import { partners } from "@/content/site";
import { SectionHeader } from "@/components/common/SectionHeader";

const slug = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, "-");

const Tile = ({ p, hidden }) => (
  <li
    className="mx-2 flex h-20 w-[180px] shrink-0 items-center justify-center border border-black/5 bg-white px-5 sm:mx-3 sm:h-24 sm:w-[210px]"
    data-testid={hidden ? undefined : `partner-logo-${slug(p.name)}`}
  >
    <img
      src={p.logo}
      alt={hidden ? "" : `${p.name} logo`}
      className={`w-auto max-w-full object-contain ${p.tall ? "max-h-16 sm:max-h-[72px]" : "max-h-10 sm:max-h-12"} ${p.mono ? "brightness-0" : ""}`}
    />
  </li>
);

// Seamless logo marquee: the list is rendered twice and shifted by half its width. Pauses on hover.
export const PartnerStrip = () => (
  <section className="pb-24 sm:pb-32" data-testid="home-partners">
    <div className="container-x">
      <SectionHeader eyebrow={partners.eyebrow} title={partners.title} className="mb-10" />
    </div>
    <div className="overflow-hidden" aria-label="SPC partners">
      <div className="flex w-max animate-[marquee_70s_linear_infinite] hover:[animation-play-state:paused]">
        {[false, true].map((hidden) => (
          <ul key={String(hidden)} className="flex shrink-0" aria-hidden={hidden || undefined}>
            {partners.list.map((p) => (
              <Tile key={p.name} p={p} hidden={hidden} />
            ))}
          </ul>
        ))}
      </div>
    </div>
  </section>
);
